import { FlexView } from '@cuemath/comps';
import { Button, Text, Separator } from '@cuemath/web-comps';
import React from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'actions/modal';

const AcLedMappingBasicConfirmationModal = ({ title, description, cta }) => {
  const dispatch = useDispatch();
  const handleCloseModal = () => dispatch(closeModal());

  return (
    <FlexView gap={24} gutter={24}>
      <Text variant="h4">{title}</Text>
      <Separator height={24} />
      <Text variant="body1Regular">{description}</Text>
      <Separator height={40} />
      <FlexView alignItems="flex-end">
        <Button size="small" label={cta} onClick={handleCloseModal} />
      </FlexView>
    </FlexView>
  );
};

export default AcLedMappingBasicConfirmationModal;
